import React from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { Translation } from "react-i18next";
import SubmitHeader from "../shared/SubmitHeader";
import { Input, Dropdown, DropdownOption } from "@abb/abb-common-ux-react";
import { DatePicker, Space } from "antd";
import * as CONSTANTS from "../../utilities/Constants";
import * as ICONCONSTANTS from "../../utilities/IconConstants";
import ISampleFormData, {
  SampleFormData,
} from "../../models/sample/SampleFormData";
import IFormComponent from "../../models/shared/FormComponent";
import ScannerViewData, {
  IScannerViewData,
} from "../../models/scanner/ScannerViewData";
import submitHeaderActions from "../../flux/actions/SubmitHeaderActions";
import sampleActions from "../../flux/actions/SampleActions";
import triggerNotifications from "../../utilities/TriggerNotifications";
import history from "../../utilities/History";
import moment from "moment";
import productActions from "../../flux/actions/ProductActions";
import testplanActions from "../../flux/actions/TestplanActions";
import gradeActions from "../../flux/actions/GradeActions";
import sourceActions from "../../flux/actions/SourceActions";
import navigationHeaderActions from "../../flux/actions/NavigationHeaderActions";
import sampleFormStore from "../../flux/stores/sample/FormStore";
import productListStore from "../../flux/stores/product/ListStore";
import testPlanListStore from "../../flux/stores/testplan/ListStore";
import gradeListStore from "../../flux/stores/grade/ListStore";
import sourceListStore from "../../flux/stores/source/ListStore";
import scannerListStore from "../../flux/stores/scanner/ListStore";
import getLatestSampleDetailStore from "../../flux/stores/sample/GetLatestSampleDetailStore";
import { IGradeViewData } from "../../models/grade/GradeViewData";
import { ISourceViewData } from "../../models/source/SourceViewData";
import DateFormatting from "../../utilities/DateFormat";
import utility from "../shared/Utility";

type PropsType = RouteComponentProps & {
  location: any;
};

interface IFormState {
  SampleFormData: ISampleFormData;
  productList: any[];
  product: any[];
  sourceList: any[];
  gradeList: any[];
  testplanList: any[];
  test: any[];
  selectedProduct: any[];
  selectedSource: any[];
  selectedTestPlan: any[];
  selectedGrade: any[];
  oldData: ISampleFormData;
  formLoading: boolean;
  nameError: boolean;
  scannerData: ScannerViewData;
  previewText: string;
}

class FormNew
  extends React.Component<PropsType, IFormState>
  implements IFormComponent {
  _mount: boolean;
  _isReload: boolean;
  _id: string;
  _messages: string[];
  _productList: any[] = [];
  _sourceList: any[] = [];
  _gradeList: any[] = [];
  _testplanList: any[] = [];
  _latestSampleDetail: any = {};
  private _listData: any[];

  constructor(props: PropsType) {
    super(props);
    const pushStateData = this.props.location.state?.formData
      ? this.props.location.state?.formData
      : (this.props.location.state as ISampleFormData);
    const scannerData = this.props.location.state?.scannerData as ScannerViewData;
    this.state = {
      SampleFormData: pushStateData,
      productList: [],
      product: [],
      sourceList: [],
      gradeList: [],
      testplanList: [],
      test: [],
      selectedProduct: [],
      selectedSource: [],
      selectedTestPlan: [],
      selectedGrade: [],
      oldData: { ...pushStateData },
      formLoading: false,
      nameError: false,
      scannerData: scannerData,
      previewText: "",
    };
    this._mount = false;
  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    this._mount = true;

    productActions
      .getAll(
        false,
        1,
        CONSTANTS.PAGE_SIZE_ALL,
        CONSTANTS.SORT_CREATEDON,
        CONSTANTS.SORT_ORDER,
        ""
      )
      .then(() => {
        this.setState(
          {
            productList: this._productList,
          },
          () => this.forceUpdate()
        );
      });
    testplanActions.getAllTp(true).then(() => {
      this.setState(
        {
          testplanList: this._testplanList,
        },
        () => this.forceUpdate()
      );
    });
    gradeActions
      .getAll(
        false,
        1,
        CONSTANTS.PAGE_SIZE_ALL,
        CONSTANTS.SORT_CREATEDON,
        CONSTANTS.SORT_ORDER,
        ""
      )
      .then(() => {
        this.setState(
          {
            gradeList: this._gradeList,
          },
          () => this.forceUpdate()
        );
      });
    sourceActions
      .getAll(
        1,
        CONSTANTS.PAGE_SIZE_ALL,
        CONSTANTS.SORT_CREATEDON,
        CONSTANTS.SORT_ORDER,
        ""
      )
      .then(() => {
        this.setState({
          sourceList: this._sourceList,
        });

        if (this.state.SampleFormData?.isEditMode) {
          let sampleDate = null;
          if (this.state.SampleFormData.sampleDate) {
            const date = new Date(this.state.SampleFormData.sampleDate);
            sampleDate =
              date.getFullYear() +
              "-" +
              (date.getMonth() > 8
                ? date.getMonth() + 1
                : "0" + (date.getMonth() + 1)) +
              "-" +
              (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) +
              " " +
              date.getHours() +
              ":" +
              date.getMinutes();
          }
          this.setState(
            {
              SampleFormData: {
                ...this.state.SampleFormData,
                sampleDate,
              },
              selectedSource: this.state.SampleFormData.sourceId
                ? [
                  {
                    value: this.state.SampleFormData.sourceId,
                    label: this.state.SampleFormData.sourceName,
                  },
                ]
                : this.state.sourceList.length > 0 ? [
                  {
                    value: this.state.sourceList[0].id,
                    label: this.state.sourceList[0].name,
                  },
                ] : [],
              selectedProduct: this.state.SampleFormData.productId
                ? [
                  {
                    value: this.state.SampleFormData.productId,
                    label: this.state.SampleFormData.productName,
                  },
                ]
                : [],
              selectedGrade: this.state.SampleFormData.gradeId
                ? [
                  {
                    value: this.state.SampleFormData.gradeId,
                    label: this.state.SampleFormData.gradeName,
                  },
                ]
                : [],
              selectedTestPlan: this.state.SampleFormData.testplanId
                ? [
                  {
                    value: this.state.SampleFormData.testplanId,
                    label: this.state.SampleFormData.testplanName,
                  },
                ]
                : [],
            },
            () => this.forceUpdate()
          );
        }
      });

    if (this.state.SampleFormData?.isEditMode) {
      submitHeaderActions
        .update({
          moduleName: CONSTANTS.MODULE_SAMPLE,
          isSubmitDisabled: false,
        })
        .then();
    }

    navigationHeaderActions
      .updateHeader({
        name: CONSTANTS.MODULE_SAMPLE,
        action: this.state.SampleFormData?.isEditMode
          ? CONSTANTS.EDIT
          : CONSTANTS.CREATE,
        icon: this.state.SampleFormData?.isEditMode
          ? ICONCONSTANTS.ABB_EDIT
          : ICONCONSTANTS.ABB_PLUS,
        goBackUrl: CONSTANTS.SAMPLE_INDEX_URL,
        isGoBackWithData: false,
        goBackData: {},
        isDataChanged: false,
      })
      .then();

    sampleFormStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._isReload = false;
        this._id = state.sampleId;
        this._messages = state.message;
      }
    });

    getLatestSampleDetailStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._latestSampleDetail = state.data;
      }
    });

    productListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        state.productDataList.result.forEach((product: any) => {
          if (product.grade?.testPlan?.isEnabled) {
            const data = {
              label: product.name,
              value: product.id,
            };
            this._productList.push(data);
          }
        });
        this.setState({
          product: state.productDataList.result,
        });
      }
    });
    testPlanListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        state.testplanDataList.result.forEach((testplan: any) => {
          const datatestplan = {
            label: testplan.name,
            value: testplan.id,
            sourceId: testplan.sourceId,
          };
          this._testplanList.push(datatestplan);
        });
      }
    });

    gradeListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        state.gradeDataList.result.forEach((grade: IGradeViewData) => {
          if (grade.testplan?.isEnabled) {
            const gradeList = {
              label: grade.name,
              value: grade.id,
            };
            this._gradeList.push(gradeList);
          }
        });
      }
    });
    sourceListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        state.sourceDataList.result.forEach((source: ISourceViewData) => {
          const data = {
            label: source.name,
            value: source.id,
          };
          this._sourceList.push(data);
        });
      }
    });

    scannerListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._listData = [];
        const data = state.data.result as IScannerViewData[];
        this._listData = data;
      }
    });

    setTimeout(() => {
      if (!this.state.SampleFormData.isEditMode && !this.state.scannerData) {
        sampleActions.getLatestSampleDetail()
          .then(() => {
            const selectedProduct = this.state.productList.find((i: any) => i.label === this._latestSampleDetail.product)
            const selectedSource = this._sourceList.find((i: any) => i.label === this._latestSampleDetail.source)
            const selectedTestPlan = this.state.testplanList.find((i: any) => i.label === this._latestSampleDetail.testPlan)
            const selectedGrade = this.state.gradeList.find((i: any) => i.label === this._latestSampleDetail.grade)
            this.setState({
              selectedProduct: selectedProduct ? [
                {
                  value: selectedProduct.value,
                  label: selectedProduct.label,
                },
              ] : [],
              selectedTestPlan: selectedTestPlan ? [
                {
                  value: selectedTestPlan.value,
                  label: selectedTestPlan.label,
                },
              ] : [],
              selectedGrade: selectedGrade ? [
                {
                  value: selectedGrade.value,
                  label: selectedGrade.label,
                },
              ] : []
            }, () => {
              selectedProduct ? this.productChangeHandler([selectedProduct]) : this.autoFillTestPlanHandler([selectedTestPlan]);
            })
            this.setState({
              selectedSource: selectedSource ? [
                {
                  value: selectedSource.value,
                  label: selectedSource.label,
                },
              ] : [],
            }, () => {
              this.sourceChangeHandler([selectedSource])
            })
          })
          .catch(() => {
            this.setState({
              selectedProduct: [],
              selectedSource: [],
              selectedTestPlan: [],
              selectedGrade: []
            })
          });
      }
    }, CONSTANTS.NOTIFICATION_TIMEOUT);
  }

  componentDidUpdate() {
    if (
      JSON.stringify(this.state.oldData) !==
      JSON.stringify(this.state.SampleFormData)
    ) {
      navigationHeaderActions
        .updateHeader({
          name: CONSTANTS.MODULE_SAMPLE,
          action: this.state.SampleFormData?.isEditMode
            ? CONSTANTS.EDIT
            : CONSTANTS.CREATE,
          icon: this.state.SampleFormData?.isEditMode
            ? ICONCONSTANTS.ABB_EDIT
            : ICONCONSTANTS.ABB_PLUS,
          goBackUrl: CONSTANTS.SAMPLE_INDEX_URL,
          isGoBackWithData: false,
          goBackData: {},
          isDataChanged: true,
        })
        .then();
    }
  }

  private setSampleDate = (value: any) => {
    this.setState({
      SampleFormData: {
        ...this.state.SampleFormData,
        sampleDate: value._d,
      },
    });
  };

  private setDescription = (value: string) => {
    this.setState({
      SampleFormData: {
        ...this.state.SampleFormData,
        description: value,
      },
    });
  };

  private setId = (value: string) => {
    this.setState({
      SampleFormData: { ...this.state.SampleFormData, setId: value },
    });
  };

  private setOrderId = (value: string) => {
    this.setState({
      SampleFormData: { ...this.state.SampleFormData, orderId: value },
    });
  };
  private testplanChangeHandler = (val: any) => {
    var newArray: any[];
    newArray = [];
    var empty: any[];
    empty = [];
    var productArray: any[];
    productArray = [];
    var testplanArray: any[];
    testplanArray = [];

    this.setState(
      {
        selectedTestPlan: val,

      }, () => {
        this.validate
      }
    );
    if (this.state.product.length !== 0) {
      this.state.product?.forEach((i) => {
        val.forEach((v: any) => {
          if (i?.grade?.testPlan?.id === v?.value[0]) {
            const data = {
              label: i.grade.name,
              value: i.grade.id,
            };
            const productData = {
              label: i.name,
              value: i.id,
            }
            newArray.push(data);
            productArray.push(productData);
            const dataTestplan = {
              label: i.grade.testPlan.name,
              value: i.grade.testPlan.id,
            };
            testplanArray.push(dataTestplan);
          } else {
            const dataTestplan = {
              label: v?.label,
              value: Array.isArray(v?.value) ? v?.value[0] : v?.value,
            };
            testplanArray.push(dataTestplan);
          }
        });
      });
    } else {
      val.forEach((v: any) => {
        const dataTestplan = {
          label: v?.label,
          value: Array.isArray(v?.value) ? v?.value[0] : v?.value,
        };
        testplanArray.push(dataTestplan);
      })
    }

    let selectedSource: any = [];
    this.state.sourceList.forEach((i: any) => {
      if (i.value === val[0]?.value[1]) {
        selectedSource.push(i);
      }
    });
    if (selectedSource.length === 0) {
      selectedSource = this.state.sourceList[0]
    }
    let selectedTestPlan: any = [];
    this.state.testplanList.forEach((i: any) => {
      if (i.value === Array.isArray(val[0]?.value) ? val[0]?.value[0] : val[0]?.value) {
        selectedTestPlan.push(i);
      }
    });
    this.setState({
      gradeList: val.length !== 0 ? utility.removeDuplicatefromArray(newArray) : this._gradeList,
      selectedGrade: null,
      selectedProduct: null,
      selectedSource: selectedSource,
      productList: val.length !== 0 ? utility.removeDuplicatefromArray(productArray) : this._productList,
      SampleFormData: {
        ...this.state.SampleFormData,
        sourceId:
          selectedSource && selectedSource.length
            ? selectedSource[0].value
            : selectedSource && selectedSource.value
              ? selectedSource.value
              : "",
        testplanId: testplanArray && testplanArray.length ? testplanArray[0].value : "",
        gradeId: "",
        productId: ""
      },
    });
  };

  private gradeChangeHandler = (val: any) => {
    var newArray: any[];
    newArray = [];
    var arrayGrade: any[];
    arrayGrade = [];
    var arrayTestplan: any[];
    arrayTestplan = [];
    let selectedSource: any = [];
    this.setState(
      {
        selectedGrade: val,
      },
      this.validate
    );
    this.state.product.forEach((i) => {
      val.forEach((v: any) => {
        if (i?.grade?.id === v?.value) {
          const data = {
            label: i.name,
            value: i.id,
          };
          newArray.push(data);
          const dataGrade = {
            label: i.grade.name,
            value: i.grade.id
          }
          arrayGrade.push(dataGrade)
          const dataTestplan = {
            label: i.grade.testPlan.name,
            value: i.grade.testPlan.id,
          };
          arrayTestplan.push(dataTestplan);
          const filterTestPlan = this.state.testplanList.find(
            (elements: any) => elements.value === i.grade.testPlan.id
          );
          if (filterTestPlan && filterTestPlan.sourceId) {
            this.state.sourceList.forEach((elems: any) => {
              if (elems.value === filterTestPlan.sourceId) {
                selectedSource = [elems];
              }
            });
          }
          if (selectedSource.length === 0) {
            selectedSource = this.state.sourceList[0]
          }
        }
      });
    });
    this.setState({
      productList: val.length !== 0 ? newArray : this._productList,
      gradeList: val.length !== 0 ? arrayGrade : this._gradeList,
      selectedTestPlan: arrayTestplan,
      selectedProduct: [],
      selectedSource,

      SampleFormData: {
        ...this.state.SampleFormData,
        sourceId:
          selectedSource && selectedSource.length
            ? selectedSource[0].value
            : selectedSource && selectedSource.value
              ? selectedSource.value
              : "",
        gradeId: arrayGrade && arrayGrade.length ? arrayGrade[0].value : "",
        testplanId: arrayTestplan.length ? arrayTestplan[0].value : "",
        productId: val.length !== 0 ? this.state.SampleFormData.productId : ""
      },
    });
  };

  private sourceChangeHandler = (val: any) => {
    this.setState(
      {
        selectedSource: val,
        SampleFormData: {
          ...this.state.SampleFormData,
          sourceId: val[0]?.value,
        },
      },
      this.validate
    );
  };

  private autoFillTestPlanHandler = (selectedTestPlan: any[]) => {
    let selectedSource: any[] = [];
    var testplanArray: any[];
    testplanArray = [];
    selectedTestPlan.forEach((v: any) => {
      const dataTestplan = {
        label: v?.label,
        value: Array.isArray(v?.value) ? v?.value[0] : v?.value,
      };
      testplanArray.push(dataTestplan);
    })
    const filterTestPlan = this.state.testplanList?.find(
      (elements: any) => elements.value === selectedTestPlan[0].value
    );
    if (filterTestPlan && filterTestPlan?.sourceId) {
      this.state.sourceList.forEach((elems: any) => {
        if (elems.value === filterTestPlan.sourceId) {
          selectedSource = [elems];
        }
      });
    }
    if (selectedSource.length === 0) {
      selectedSource = this.state.sourceList
    }
    this.setState({
      productList: [],
      gradeList: [],
      SampleFormData: {
        ...this.state.SampleFormData,
        sourceId:
          selectedSource && selectedSource.length
            ? selectedSource[0].value
            : "",
        productId: "",
        gradeId: "",
        testplanId: testplanArray && testplanArray.length ? testplanArray[0].value : "",
      },
    });
  }

  private productChangeHandler = (val: any) => {
    var arrayGrade: any[];
    arrayGrade = [];
    var arrayProduct: any[];
    arrayProduct = [];
    var arrayTestplan: any[];
    arrayTestplan = [];
    let selectedSource: any = [];
    this.setState(
      {
        selectedProduct: val,
      },
      this.validate
    );
    this.state.product.forEach((i) => {
      val.forEach((v: any) => {
        if (i?.id === v?.value) {
          const dataProduct = {
            label: i.name,
            value: i.id
          }
          arrayProduct.push(dataProduct)
          const dataGrade = {
            label: i.grade.name,
            value: i.grade.id,
          };
          arrayGrade.push(dataGrade);
          const dataTestplan = {
            label: i.grade.testPlan.name,
            value: i.grade.testPlan.id,
          };
          arrayTestplan.push(dataTestplan);
          const filterTestPlan = this.state.testplanList?.find(
            (elements: any) => elements.value === i.grade.testPlan.id
          );
          if (filterTestPlan && filterTestPlan?.sourceId) {
            this.state.sourceList.forEach((elems: any) => {
              if (elems.value === filterTestPlan.sourceId) {
                selectedSource = [elems];
              }
            });
          }
          if (selectedSource.length === 0) {
            selectedSource = this.state.sourceList[0]
          }
        }
      });
    });
    this.setState({
      selectedGrade: arrayGrade,
      selectedTestPlan: arrayTestplan,
      productList: val.length !== 0 ? arrayProduct : this._productList,
      gradeList: val.length !== 0 ? arrayGrade : this._gradeList,
      selectedSource,
      SampleFormData: {
        ...this.state.SampleFormData,
        sourceId:
          selectedSource && selectedSource.length
            ? selectedSource[0].value
            : selectedSource && selectedSource.value
              ? selectedSource.value
              : "",
        productId: arrayProduct && arrayProduct.length ? arrayProduct[0].value : "",
        gradeId: arrayGrade && arrayGrade.length ? arrayGrade[0].value : "",
        testplanId: arrayTestplan && arrayTestplan.length ? arrayTestplan[0].value : ""
      },
    });
  };

  private setName = (value: string) => {
    const val = value.length > 1 ? value : value.replace(/\s/g, "");
    var rgFile = CONSTANTS.COMMONREGEXP;
    if (value.trim() && !rgFile.test(value)) {
      this.setState(
        {
          nameError: false,
          SampleFormData: { ...this.state.SampleFormData, name: val },
        },
        this.validate
      );
    } else {
      this.setState(
        {
          nameError: true,
          SampleFormData: { ...this.state.SampleFormData, name: val },
        },
        this.validate
      );
    }
  };

  validate(): void {
    if (
      !this.state.nameError &&
      this.state.SampleFormData.name &&
      this.state.SampleFormData.name.trim() !== CONSTANTS.DefaultGuid
    ) {
      submitHeaderActions
        .update({
          moduleName: CONSTANTS.MODULE_SAMPLE,
          isSubmitDisabled: false,
        })
        .then();
    } else {
      submitHeaderActions
        .update({
          moduleName: CONSTANTS.MODULE_SAMPLE,
          isSubmitDisabled: true,
        })
        .then();
    }
  }

  public onSaveClick = () => {
    const tempName = this.state.SampleFormData.name
      .replace(/ +(?= )/g, "")
      .trim();
    this.setState(
      (prevState) => ({
        formLoading: true,
        SampleFormData: {
          ...prevState.SampleFormData,
          name: tempName,
        },
      }),
      () => {
        let date = null;
        if (this.state.SampleFormData.sampleDate) {
          date = new Date(this.state.SampleFormData.sampleDate).toISOString();
        }
        const data = new SampleFormData(
          this.state.SampleFormData?.isEditMode,
          this.state.SampleFormData.requestId,
          this.state.SampleFormData.id,
          this.state.SampleFormData.name,
          this.state.SampleFormData.description,
          this.state.SampleFormData.productId,
          this.state.SampleFormData.sourceId,
          this.state.SampleFormData.orderId,
          this.state.SampleFormData.setId,
          date,
          "",
          "",
          "",
          this.state.SampleFormData.gradeId,
          Array.isArray(this.state.SampleFormData.testplanId) ? this.state.SampleFormData.testplanId[0] : this.state.SampleFormData.testplanId
        );

        sampleActions
          .put(data)
          .then(() => {
            this.setState(
              {
                formLoading: false,
              },
              () => {
                triggerNotifications.success(this._messages);
                setTimeout(() => {
                  history.push(CONSTANTS.SAMPLE_INDEXNEW_URL);
                }, CONSTANTS.NOTIFICATION_TIMEOUT);
              }
            );
          })
          .catch((error: any) => {
            this.setState(
              {
                formLoading: false,
              },
              () =>
                triggerNotifications.errors(error.message, error.data).then()
            );
          });
      }
    );
  };

  public onCreateClick = () => {
    const tempName = this.state.SampleFormData.name
      .replace(/ +(?= )/g, "")
      .trim();
    this.setState(
      (prevState) => ({
        formLoading: true,
        SampleFormData: {
          ...prevState.SampleFormData,
          name: tempName,
        },
      }),
      () => {
        const data = new SampleFormData(
          this.state.SampleFormData?.isEditMode,
          this.state.SampleFormData.requestId,
          this.state.SampleFormData.id,
          this.state.SampleFormData.name,
          this.state.SampleFormData.description,
          this.state.SampleFormData.productId,
          this.state.SampleFormData.sourceId,
          this.state.SampleFormData.orderId,
          this.state.SampleFormData.setId,
          this.state.SampleFormData.sampleDate,
          "",
          "",
          "",
          this.state.SampleFormData.gradeId,
          Array.isArray(this.state.SampleFormData.testplanId) ? this.state.SampleFormData.testplanId[0] : this.state.SampleFormData.testplanId
        );
        sampleActions
          .post(data)
          .then(() => {
            this.setState(
              {
                formLoading: false,
              },
              () => {
                triggerNotifications.success(this._messages);
                setTimeout(() => {
                  history.push(CONSTANTS.SAMPLE_INDEXNEW_URL);
                }, CONSTANTS.NOTIFICATION_TIMEOUT);
              }
            );
          })
          .catch((error) => {
            this.setState(
              {
                formLoading: false,
              },
              () =>
                triggerNotifications.errors(error.message, error.data).then()
            );
          });
      }
    );
  };

  private onScannerPaste = (e: any) => {
    this.setState(
      {
        previewText: e,
      },
      () => {
        if (this.state.scannerData.delimiterValue === CONSTANTS.DELIMITER) {
          const arr = this.state.previewText.split(
            this.state.scannerData.delimiter
          );
          const mappings: any[] = [];
          let selectedProduct: any[] = [];
          let selectedGrade: any[] = [];
          let selectedTestPlan: any[] = [];
          let selectedSource: any[] = [];
          const sampleFormData = this.state.SampleFormData;
          this.state.scannerData?.mappings?.map((d, i) => {
            if (d.sampleFieldKey === "Sample Name") {
              sampleFormData.name = arr[i];
            } else if (d.sampleFieldKey === "Order ID") {
              sampleFormData.orderId = arr[i] || "";
            } else if (d.sampleFieldKey === "Set No") {
              sampleFormData.setId = arr[i] || "";
            } else if (d.sampleFieldKey === "Description") {
              sampleFormData.description = arr[i];
            } else if (d.sampleFieldKey === "Product") {
              const product = this._productList.find(
                (x) => x.label?.trim() === arr[i]?.trim()
              );
              if (product !== undefined) {
                selectedProduct = [product];
                sampleFormData.productId = product.value;
              }
            } else if (d.sampleFieldKey === "Grade") {
              const grade = this._gradeList.find(
                (x) => x.label?.trim() === arr[i]?.trim()
              );
              if (grade !== undefined) {
                selectedGrade = [grade];
                sampleFormData.gradeId = grade.value;
              }
            } else if (d.sampleFieldKey === "Test Plan") {
              const testPlan = this.state.testplanList.find(
                (x) => x.label?.trim() === arr[i]?.trim()
              );
              if (testPlan !== undefined) {
                selectedTestPlan = [testPlan];
                sampleFormData.testplanId = testPlan.value;
              }
            } else if (d.sampleFieldKey === "Source") {
              const source = this.state.sourceList.find(
                (x) => x.label?.trim() === arr[i]?.trim()
              );
              if (source !== undefined) {
                selectedSource = [source];
                sampleFormData.sourceId = source.value;
              }
            } else if (d.sampleFieldKey === "Date") {
              sampleFormData.sampleDate = "";
              if (
                arr[i] &&
                arr[i].toString().toLocaleLowerCase().includes("pm")
              ) {
                sampleFormData.sampleDate = moment(
                  arr[i].toString().toLocaleLowerCase().split("pm").join(" pm")
                ).format("YYYY-MM-DD hh:mm A");
              } else if (
                arr[i] &&
                arr[i]?.toString()?.toLocaleLowerCase()?.includes("am")
              ) {
                sampleFormData.sampleDate = moment(
                  arr[i].toString()?.toLocaleLowerCase()?.split("am")?.join(" am")
                ).format("YYYY-MM-DD hh:mm A");
              } else {
                sampleFormData.sampleDate = moment(arr[i]?.toString())?.format(
                  "YYYY-MM-DD hh:mm A"
                );
              }

              sampleFormData.formatedDate = sampleFormData.sampleDate
                ? moment.utc(sampleFormData.sampleDate).format(DateFormatting.getDateTimeRegion())
                : null;
            }
            mappings.push({ ...d, dataValue: arr[i] });
          });

          this.setState(
            {
              SampleFormData: sampleFormData,
              selectedProduct,
              selectedGrade,
              selectedTestPlan,
              selectedSource,
            },
            this.validate
          );
        } else {
          const sampleFormData = this.state.SampleFormData;
          let selectedProduct: any[] = [];
          let selectedGrade: any[] = [];
          let selectedTestPlan: any[] = [];
          let selectedSource: any[] = [];
          this.state.scannerData?.mappings?.map((d, i) => {
            const dataValue = this.state.previewText.substring(
              d.startIndex - 1,
              d.endIndex
            );
            if (d.sampleFieldKey === "Sample Name") {
              sampleFormData.name = dataValue;
            } else if (d.sampleFieldKey === "Order ID") {
              sampleFormData.orderId = dataValue || "";
            } else if (d.sampleFieldKey === "Set No") {
              sampleFormData.setId = dataValue || "";
            } else if (d.sampleFieldKey === "Description") {
              sampleFormData.description = dataValue;
            } else if (d.sampleFieldKey === "Product") {
              const product = this._productList.find(
                (x) => x.label?.trim() === dataValue?.trim()
              );
              if (product !== undefined) {
                selectedProduct = [product];
                sampleFormData.productId = product.value;
              }
            } else if (d.sampleFieldKey === "Grade") {
              const grade = this._gradeList.find(
                (x) => x.label?.trim() === dataValue?.trim()
              );
              if (grade !== undefined) {
                selectedGrade = [grade];
                sampleFormData.gradeId = grade.value;
              }
            } else if (d.sampleFieldKey === "Test Plan") {
              const testPlan = this._testplanList.find(
                (x) => x.label?.trim() === dataValue?.trim()
              );
              if (testPlan !== undefined) {
                selectedTestPlan = [testPlan];
                sampleFormData.testplanId = testPlan.value;
              }
            } else if (d.sampleFieldKey === "Source") {
              const source = this._sourceList.find(
                (x) => x.label?.trim() === dataValue?.trim()
              );
              if (source !== undefined) {
                selectedSource = [source];
                sampleFormData.sourceId = source.value;
              }
            } else if (d.sampleFieldKey === "Date") {
              sampleFormData.sampleDate =
                new Date(dataValue?.trim()).toString() || "";

              sampleFormData.formatedDate = sampleFormData.sampleDate
                ? moment.utc(DateFormatting.getDateTimeRegionOffset()).format(DateFormatting.getDateTimeRegion())
                : null;
            }
          });
          this.setState(
            {
              selectedProduct,
              SampleFormData: sampleFormData,
              selectedGrade,
              selectedTestPlan,
              selectedSource,
            },
            this.validate
          );
        }
      }
    );
  };

  onCancelClick = () => {
    history.push(CONSTANTS.SAMPLE_INDEXNEW_URL, {
      isReloadFirst: this._isReload,
      id: this._id,
    });
  };

  public render() {
    return (
      <Translation>
        {(t) => (
          <div className="">
            <div className="layout-container">
              <SubmitHeader
                name="Sample"
                isEdit={this.state.SampleFormData?.isEditMode}
                onSaveClick={this.onSaveClick}
                onCancelClick={this.onCancelClick}
                onCreateClick={this.onCreateClick}
                isLoading={this.state.formLoading}
              />
              <div className="mt-4">
                <div className="col-6 no-padding float-left">
                  <div className="box box-height-sample-2">
                    <div className="box-circle">
                      <p className="box-circle-text"> 1 </p>
                    </div>
                    <div className="ml-4">
                      <p className="sidebar-main-title font-weight-bold ml-2">
                        {t(
                          CONSTANTS.MODULE_SAMPLE +
                          " " +
                          CONSTANTS.TITLE_TESTOVERVIEW_DETAILS
                        )}
                      </p>
                    </div>
                    <hr className="hr-line" />

                    {!this.state.SampleFormData?.isEditMode &&
                      this.state.scannerData !== undefined && (
                        <div className="mt-1 form-group margin-16">
                          <label className="text-preview mb-0">
                            {t(CONSTANTS.LABEL_PREVIEW)}
                          </label>
                          <div>
                            <Input
                              inputAttributes={{ autoFocus: "true" }}
                              dataType="text"
                              className="mt-2 w-100"
                              value={this.state.previewText}
                              onValueChange={this.onScannerPaste}
                            />
                          </div>
                        </div>
                      )}

                    <div className="row mt-3">
                      <div className="col-sm col-md">
                        <Input
                          inputAttributes={
                            this.state.scannerData === undefined
                              ? { autoFocus: "true" }
                              : {}
                          }
                          dataType="text"
                          placeholder={t(CONSTANTS.LABLE_NAME)}
                          label={t(CONSTANTS.LABLE_NAME)}
                          required={true}
                          className={
                            this.state.nameError
                              ? "error-code mt-2 w-50"
                              : "mt-2 w-50"
                          }
                          value={this.state.SampleFormData?.name}
                          onValueChange={this.setName}
                          maxLength={250}
                          showValidationBarWhenInvalid={this.state.nameError}
                          description={
                            this.state.nameError
                              ? this.state.SampleFormData.name.length
                                ? t(CONSTANTS.NAME_VALIDATION_ERROR)
                                : t(CONSTANTS.FIELD_EMPTY_ERROR)
                              : ""
                          }
                        />
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-sm col-md">
                        <div style={{ color: "#696969", fontSize: "14px" }}>
                          {t(CONSTANTS.DATE)}{" "}
                          <span className="required_header">*</span>
                        </div>

                        <Space direction="vertical" size={12}>
                          <DatePicker
                            format={DateFormatting.getDateTimeRegion() || "DD-MM-YYYY hh:mm A"}
                            showTime={{ use12Hours: true, format: "hh:mm A" }}
                            defaultValue={
                              this.state.SampleFormData?.sampleDate
                                ? moment(this.state.SampleFormData?.sampleDate)
                                : null
                            }
                            value={moment(this.state.SampleFormData?.sampleDate)}
                            onChange={this.setSampleDate}
                            onOk={this.setSampleDate}
                            allowClear={true}
                            bordered={true}
                            placeholder={DateFormatting.getDateTimeRegion() || "DD-MM-YYYY hh:mm A"}
                          />
                        </Space>
                      </div>
                    </div>

                    {!this.state.scannerData ? (
                      <React.Fragment>
                        <div className="row mt-3">
                          <div className="col-sm-6 col-md-6">
                            <Input
                              dataType="text"
                              placeholder={t(CONSTANTS.LABEL_ORDERID)}
                              label={t(CONSTANTS.LABEL_ORDERID)}
                              className="mt-2 w-50"
                              value={String(this.state.SampleFormData?.orderId)}
                              onValueChange={this.setOrderId}
                            />
                          </div>
                          <div className="col-sm-6 col-md-6">
                            <Input
                              dataType="text"
                              placeholder={t(CONSTANTS.LABEL_SETID)}
                              label={t(CONSTANTS.LABEL_SETID)}
                              className="mt-2 w-50 text-nowrap"
                              value={String(this.state.SampleFormData?.setId)}
                              onValueChange={this.setId}
                            />
                          </div>
                        </div>

                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <div className="row mt-3">
                          <div className="col-sm-6 col-md-6">
                            <Input
                              dataType="text"
                              placeholder={t(CONSTANTS.LABEL_ORDERID)}
                              label={t(CONSTANTS.LABEL_ORDERID)}
                              className="mt-2 w-100"
                              value={String(this.state.SampleFormData.orderId)}
                              onValueChange={this.setOrderId}
                              maxLength={10}
                            />
                          </div>
                          <div className="col-sm-6 col-md-6">
                            <Input
                              dataType="text"
                              placeholder={t(CONSTANTS.LABEL_SETID)}
                              label={t(CONSTANTS.LABEL_SETID)}
                              className="mt-2 w-100 text-nowrap"
                              value={String(this.state.SampleFormData.setId)}
                              onValueChange={this.setId}
                              maxLength={10}
                            />
                          </div>
                        </div>
                      </React.Fragment>
                    )}
                    <div className="row mt-3">
                      <div className="col-sm col-md">
                        <Input
                          dataType="textarea"
                          label={t(CONSTANTS.LABEL_DESCRIPTION)}
                          placeholder={t(CONSTANTS.LABEL_DESCRIPTION)}
                          value={this.state.SampleFormData?.description}
                          onValueChange={this.setDescription}
                          inputAttributes={{ rows: "4" }}
                          className="mt-2 h-25"
                          resizable={false}
                          maxLength={500}
                        />
                      </div>
                    </div>
                    <div className="row mt-3 ml-1">
                      <div>
                        {500 - this.state.SampleFormData?.description?.length}{" "}
                        {t("character left out of 500 character")}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-6 no-padding float-left">
                  <div className="box box-height-sample-2 ml-4">
                    <div className="box-circle">
                      <p className="box-circle-text"> 2 </p>
                    </div>
                    <div className="ml-4">
                      <p className="sidebar-main-title font-weight-bold ml-2">
                        {t(CONSTANTS.LABLE_ADDITIONAL_INFORMATION)}
                      </p>
                    </div>
                    <hr className="hr-line" />
                    <div className="row mt-4">
                      <div className="col-sm-6 col-md-6">
                        <div style={{ color: "#696969", fontSize: "14px" }}>
                          {t(CONSTANTS.MODULE_TESTPLAN)}{" "}
                          <span className="required_header_blue">*</span>
                        </div>
                        <Dropdown
                          allowAdd={false}
                          clearable={true}
                          placeholder={
                            t(CONSTANTS.LABEL_SELECT) +
                            " " +
                            t(CONSTANTS.MODULE_TESTPLAN)
                          }
                          searchable={true}
                          value={this.state.selectedTestPlan}
                          onChange={this.testplanChangeHandler}
                        >
                          {this.state.testplanList.map((o) => (
                            <DropdownOption
                              key={o.value}
                              label={o.label}
                              value={[o.value, o.sourceId]}
                            />
                          ))}
                        </Dropdown>
                      </div>
                    </div>

                    <div className="row mt-2">
                      <div className="col-sm-6 col-md-6">
                        <Dropdown
                          label={
                            t(CONSTANTS.MODULE_GRADE)
                          }
                          allowAdd={false}
                          clearable={true}
                          placeholder={
                            t(CONSTANTS.LABEL_SELECT) +
                            " " +
                            t(CONSTANTS.MODULE_GRADE)
                          }
                          searchable={true}
                          value={this.state.selectedGrade}
                          onChange={this.gradeChangeHandler}
                        >
                          {this.state.gradeList.map((o) => (
                            <DropdownOption
                              key={o.value}
                              label={o.label}
                              value={o.value}
                            />
                          ))}
                        </Dropdown>
                      </div>
                    </div>

                    <div className="row mt-2">
                      <div className="col-sm-6 col-md-6">
                        <div style={{ color: "#696969", fontSize: "14px" }}>
                          {t(CONSTANTS.MODULE_PRODUCT)}{" "}
                        </div>
                        <Dropdown
                          allowAdd={false}
                          clearable={true}
                          placeholder={
                            t(CONSTANTS.LABEL_SELECT) +
                            " " +
                            t(CONSTANTS.MODULE_PRODUCT)
                          }
                          searchable={true}
                          value={this.state.selectedProduct}
                          onChange={this.productChangeHandler}
                        >
                          {this.state.productList.map((o) => (
                            <DropdownOption
                              key={o.value}
                              label={o.label}
                              value={o.value}
                            />
                          ))}
                        </Dropdown>
                      </div>
                    </div>

                    <div className="row mt-2">
                      <div className="col-sm-6 col-md-6">
                        <div style={{ color: "#696969", fontSize: "14px" }}>
                          {t(CONSTANTS.MODULE_SOURCE)}{" "}
                        </div>
                        <Dropdown
                          allowAdd={false}
                          clearable={true}
                          placeholder={
                            t(CONSTANTS.LABEL_SELECT) +
                            " " +
                            t(CONSTANTS.MODULE_SOURCE)
                          }
                          searchable={true}
                          value={this.state.selectedSource}
                          onChange={this.sourceChangeHandler}
                        >
                          {this._sourceList.map((o) => (
                            <DropdownOption
                              key={o.value}
                              label={o.label}
                              value={o.value}
                            />
                          ))}
                        </Dropdown>
                      </div>
                    </div>

                    <div className="row mt-2">
                      <div className="col-sm-6 col-md-6 sample_remarks">
                        {t("Note :")} <span className="required_header_blue">*</span>{" "}
                        {t("Required for measurements")}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="clearfix" />
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

export default withRouter(FormNew);
